import ElementUI from 'element-ui'
import Vue from 'vue'
import './element-ui.scss'

const navigatorLanguage = window.navigator.language.split('-')[0]
const loadLanguage = (lang) => import(`element-ui/lib/locale/lang/${lang}`)
const locale = loadLanguage(navigatorLanguage)

Vue.use(ElementUI, { locale })
